import React from 'react';

const VideoContainer = ({children}) => {
  return (
    <div className="mobile:mt-0 m-auto md:w-[80%] lg:w-[860px]">
      {children}
    </div>
  );
}

export default VideoContainer;
